import React, {FC} from "react"
import Spacing from "@irati/ui/src/Spacing"
import SearchBrands from "@irati/deals/apollo/query/SearchBrands"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"
import DealBrandResults from "@irati-web/search/src/components/DealBrandResults"
import {DealListVariables} from "@irati/deals/apollo/query/DealList"
import {DealCategory} from "@irati/types"
import Loading from "@irati/ui/src/Loading"
import {useBlackListedCategories} from "@irati/deals/hooks"

interface Props extends WithPerkOrReward {
  dealQueryVars: DealListVariables
  category?: DealCategory
}

const CategoriesBrands: FC<Props> = ({isRewards, dealQueryVars, category}) => {
  const {data, load} = useBlackListedCategories({}, {skip: isRewards})
  if (data?.includes(category?.uuid!)) return null

  return (
    <Loading load={load}>
      <Spacing margin={[2, 0]}>
        <SearchBrands variables={dealQueryVars}>
          {(dealBrandResponse) => {
            if (dealBrandResponse.error || !dealBrandResponse.data?.dealsBrands) return null

            return <DealBrandResults dealBrands={dealBrandResponse.data?.dealsBrands} wasClickedFromCategories hasCategorySettings />
          }}
        </SearchBrands>
      </Spacing>
    </Loading>
  )
}

export default withPerkOrReward(CategoriesBrands)
